import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { forEach } from 'lodash';
import { AuctionItemSellHistory, AuctionService, DateUtilsService, DateTimeFormat } from 'remarketing-angular-library';
import { PurchaseHistory } from '@ally/remarketing/shared/dto';
import { MapHistoryByDateService } from '@ally/remarketing/shared/services';
import {
  CurrencyFormatService,
  PurchaseStatusPipe,
  SaComponent
} from 'smartauction-frontend-micro-library';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { TooltipComponent } from 'remarketing-ui-components-lib';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-purchase-history',
    templateUrl: './purchase-history.component.html',
    styleUrls: ['./purchase-history.component.scss'],
    imports: [TranslocoDirective, PurchaseStatusPipe, TooltipComponent, CommonModule]
})
export class PurchaseHistoryComponent extends SaComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter();
  @Input() vehicleVin: string;
  @Input() saleDate: string;
  @Input() salePrice: number;
  @Input() auctionItemUuid: string;
  private _isVisible = false;

  purchaseHistoryTranslations = {
    textVIN: ''
  };

  @Input() set isVisible(isVisible: boolean) {
    this._isVisible = isVisible;
    if (this._isVisible) {
      setTimeout(() => this.heading.nativeElement.focus());
    }
  }
  get isVisible() {
    return this._isVisible;
  }

  @ViewChild('heading') heading: ElementRef<HTMLHeadingElement>;

  purchaseOfferHistory: PurchaseHistory;
  historyCount = 0;

  isMobile: boolean;

  constructor(
    private readonly auctionItemService: AuctionService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    readonly dateUtilService: DateUtilsService,
    private readonly currencyFormatService: CurrencyFormatService,
    private readonly translocoService: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.getTranslations();
    this.getAuctionItemSellHistory(this.auctionItemUuid);
  }

  localizeDate(date) {
    return this.dateUtilService.localizeDate(date);
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.detectIfMobile();
  }

  getAuctionItemSellHistory(auctionItemUuid) {
    this.auctionItemService
      .getAuctionItemSellHistory(auctionItemUuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(purchaseHistory => {
        this.purchaseOfferHistory = MapHistoryByDateService.mapPurchaseHistory(purchaseHistory);
        const dates = this.purchaseOfferHistory.purchaseByDate;
        let count = 0;
        if (this.purchaseOfferHistory) {
          forEach(dates, key => {
            count += key.length;
          });
        }
        this.historyCount = count;
        this.changeDetectorRef.markForCheck();
      });
  }

  systemTransaction(auctionItemSellHistory: AuctionItemSellHistory) {
    return (
      auctionItemSellHistory.type === 'CANCELLED' ||
      auctionItemSellHistory.type === 'OFFER_EXPIRED' ||
      auctionItemSellHistory.type === 'BID_CANCELLED' ||
      auctionItemSellHistory.type === 'VEHICLE_REMOVED'
    );
  }

  offerDate(date) {
    return this.dateUtilService.formatDate(date, DateTimeFormat.H_MM_A, true);
  }

  comment(transaction) {
    return transaction.comments && transaction.comments !== '' ? transaction.comments : 'N/A';
  }

  closeHistory() {
    this.close.emit();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getTransactionUserName(transaction) {
    return transaction.userName ? transaction.userName : '';
  }

  detectIfMobile() {
    this.isMobile = window.matchMedia('(max-width: 645px)').matches;
  }

  formatCurrency(currency) {
    return this.currencyFormatService.formatCurrency(currency);
  }

  formatTime(time) {
    return `${this.dateUtilService.localizeTime(time)} ET`;
  }

  getTranslations(): void {
    const keyParams = {
      'auctionSummary.auctionHistoryModal': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.purchaseHistoryTranslations.textVIN = translate[0].textVIN;
      });
  }
}
